import Vue from 'vue'

import VeeValidate, { Validator } from 'vee-validate' // Forms field validation
import fr from 'vee-validate/dist/locale/fr'; // Forms field I18n
import en from 'vee-validate/dist/locale/en'; // Forms field I18n
import VueMQ from 'vue-mq' // responsive library
import VueQrcodeReader from "vue-qrcode-reader"; // QR Code
import Simplert from 'vue2-simplert-plugin' // Alert
require('vue2-simplert-plugin/dist/vue2-simplert-plugin.css') // Alert
import VueAwesomeSwiper from 'vue-awesome-swiper' // Slider
import 'swiper/css/swiper.css' // Slider
import VModal from 'vue-js-modal' // Modal & Popup
import VueGtm from '@gtm-support/vue2-gtm' // Google Tag Manager


import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import i18n from './i18n'
import * as firestoreServices from './lib/firestore'
import remoteConfig from './lib/remote-config'
require('./lib/hotjar/hotjar.js')
import { addNotification } from './services/notification'
import './directives'
import testIds from '../tests/e2e/identifiers'

import './assets/styles/main.scss'

import { eventBus } from './helpers/eventBus'
import { legalAge } from './helpers/rules/date'
import CONST from './CONST'

//partie liaison de firebase 
import firebase from 'firebase';
require('firebase/firestore');
import "firebase/analytics";


// Initialize Firebase
Vue.prototype.$firebase = firebase;

Vue.config.productionTip = false;
//fin liaison firebase

localStorage.vuex = null

// Add firestore instance to Vue prototype
Vue.prototype.$firestore = firestoreServices
Vue.prototype.$addNotification = addNotification
Vue.prototype.$cypress = testIds
Vue.prototype.$const = CONST
Vue.prototype.$eventBus = eventBus

/** Plugins */
// Validator
const dictionary = {
  en: {
    messages: {
      legalAge: 'You are not of legal age.',
      ...en.messages
    }
  },
  fr: {
    messages: {
      legalAge: "Vous n'avez pas l'âge légal requis.",
      ...fr.messages
    }
  }
}
Vue.use(VeeValidate)
Validator.extend('legalAge', legalAge)
Validator.localize(dictionary)
// VueMQ
Vue.use(VueMQ, {
  breakpoints: {
    mobile: 450,
    tablet: 1025,
    desktop: Infinity
  }
})

Vue.use(VueQrcodeReader) // QR Code
Vue.use(Simplert) // Alert
Vue.use(VueAwesomeSwiper) // Slider
Vue.use(VModal, {dynamic: true, injectModalsContainer: true}) // Modal & popup

// eslint-disable-next-line
// Vue.prototype.$stripe = new Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY)

// Google Tag Manager
Vue.use(VueGtm, {
  id: 'GTM-PQXNKD3', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  queryParams: {
    // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    gtm_preview: 'env-4',
    gtm_cookies_win: 'x'
  },
  defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: true, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  nonce: '2726c7f26c', // Will add `nonce` to the script tag
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: false, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  ignoredViews: [], // Don't trigger events for specified router names (optional)
  trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
});

remoteConfig.initialize().then(() => {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})
